import React, { useEffect, useRef } from 'react';
import Card from './Card';
import weightLossImage1 from '../assets/Weightloss-img1_2.png';
import weightLossImage2 from '../assets/Weightloss-img2_2.png';
import weightLossImage3 from '../assets/Weightloss-img3.png';
import weightLossImage4 from '../assets/Weightloss-img4_2.png';
import observer from '../utils/observer';

const CardSection = () => {
  const refValue = useRef(null);
  useEffect(() => {
    observer(refValue, 'section-hidden');
  }, [refValue]);

  return (
    <div className="cards-section-container section-hidden" ref={refValue}>
      <div className="cards-section-header">
        {/* Weight loss is demystified in 4, simple ways */}
        Real People, Real Results
      </div>
      <div className="cards-section-sub-header">
        {/* Our science-backed weight methods ensure you lose weight the healthy way */}
        Fast-track your goals with our personalized approach to fitness and
        wellness
      </div>
      <div className="cards-container ">
        <Card
          cardHeader={`Nutrient Dense meals`}
          cardText={`Indulge in meals rich in dietary fiber and essential macro nutrients, meticulously designed to support your weight loss and wellness goals. Each meal is personalized for every user and endorsed by our Nutritionist/Dietician who is a member of the Dieticians Association of Nigeria.`}
          cardNumber={`01`}
          altText={`healthy meals`}
          image={weightLossImage1}
          isVerticalImage={false}
          isReversed={false}
        />
        <Card
          cardHeader={`Portion control guide`}
          cardText={`Less is more, but it's not just about eating less. Our personalized portion control guide ensures you eat the right food in the right portions for effective and sustainable weight management.`}
          cardNumber={`02`}
          altText={`portion control`}
          image={weightLossImage2}
          isVerticalImage={false}
          isReversed={true}
        />
        <Card
          cardHeader={`Home Workout`}
          cardText={`Our personalized, simple, and replicable daily home workouts kick-start science-backed metabolic processes, promoting effective and sustainable weight loss for a transformative journey.`}
          cardNumber={`03`}
          altText={`daily exercise`}
          image={weightLossImage3}
          isVerticalImage={true}
          isReversed={false}
        />
        <Card
          cardHeader={`Intermittent fasting`}
          cardText={`Your body has two fuel sources: food and stored food. For a specified duration, our users tap into stored energy during fasting, often while asleep for convenience.`}
          cardNumber={`04`}
          altText={`intermittent fasting`}
          image={weightLossImage4}
          isVerticalImage={false}
          isReversed={true}
        />
      </div>
    </div>
  );
};

export default CardSection;
